<app-header
  canvasMode="blank"
  [loggedIn]="true"
  [fixedHeader]="true"
></app-header>
<div class="home-container">
  <div class="top">Access Denied</div>
  <div class="line"></div>
  <h1>
    <p>You do not have access to this page.</p>
  </h1>
  <div class="bottom">
    Please contact your administrator for assistance
    <BR /><BR /> Take me to the
    <a [routerLink]="['/reports']">Report library </a> or the
    <a [routerLink]="['/dshboards']">Dashboard library </a>
  </div>
</div>
